import React from "react";
import axios from 'axios';
import Breadcrumb from '../Components/Breadcrumb';
class Media extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            media : []
        }
    };
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Web Page/media'), {
            headers : {'Authorization' : process.env.REACT_APP_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({media:response.data['data']})
            //console.log(response.data.data)  
        })
    } 
  render() {
    const rawHTML =this.state.media.main_section_html
    return<div>
            <Breadcrumb head="Media"/>
            <div className="container"> 
                <div className="row" dangerouslySetInnerHTML={{ __html: rawHTML }}/>
                   
            </div>
         </div>
            }
        }
        
        export default Media;
        